/**
 * Google Analytics tracking utilities using react-ga4
 */
import ReactGA from 'react-ga4';

/**
 * Initialize Google Analytics
 * Should be called once at app startup
 */
export const initGA = () => {
  ReactGA.initialize('G-YRX13BFZ2Y');
};

/**
 * Track a page view in Google Analytics
 * @param path - The page path to track (e.g., "/login", "/practice-area")
 */
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

/**
 * Track a custom event in Google Analytics
 * @param category - Event category (e.g., "Practice", "Paper")
 * @param action - Event action (e.g., "Started Practice Set", "Submitted Answer")
 * @param label - Optional event label (e.g., "Q4", "Paper 1")
 * @param value - Optional numeric value
 */
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
